import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { Transition, UIRouterModule } from '@uirouter/angular';
import { processResolver } from '../efaact-routing/process-resolver';
import { CategoriesService } from '../shared/category/categories.service';
import * as fromCheckup from './features';

@NgModule({
    imports: [
        CommonModule,
        UIRouterModule.forChild({
            // TODO: will having all these here mess with lazy loading of modules?
            // https://ui-router.github.io/guide/lazyloading
            states: [
                {
                    // name: 'efcheckup.**',
                    name: 'efcheckup',
                    url: '/efcheckup',
                    // loadChildren: () => import('./checkup.module').then(r => r.CheckupModule),
                    data: { requiresAuth: true },
                    params: { process: {} },
                    resolve: [
                        {
                            token: 'process',
                            deps: [Transition, CategoriesService],
                            resolveFn: processResolver
                        }
                    ],
                    component: fromCheckup.CheckupFeatureComponent
                },
                {
                    name: 'efcheckup.timecard',
                    url: '/timecard',
                    component: fromCheckup.CheckupFeatureComponent
                },
                {
                    name: 'efcheckup.expense',
                    url: '/expense',
                    component: fromCheckup.CheckupFeatureComponent
                },
                {
                    name: 'efcheckup.qbsynclists',
                    url: '/qbsynclists',
                    component: fromCheckup.CheckupFeatureComponent
                },
                {
                    name: 'efcheckup.qbsendhours',
                    url: '/qbsendhours',
                    component: fromCheckup.CheckupFeatureComponent
                },
                {
                    name: 'efcheckup.qbsendexpenses',
                    url: '/qbsendexpenses',
                    component: fromCheckup.CheckupFeatureComponent
                },
                {
                    name: 'efcheckup.qbprocessperiod',
                    url: '/qbprocessperiod',
                    component: fromCheckup.CheckupFeatureComponent
                },
                {
                    name: 'efcheckup.qbsendeinvoices',
                    url: '/qbsendeinvoices',
                    component: fromCheckup.CheckupFeatureComponent
                }
            ]
        })
    ]
})
export class CheckupRouteModule {}
